// extracted by mini-css-extract-plugin
export default {"warper":"IndicatorBox_warper__xLr8H","upSide":"IndicatorBox_upSide__GjFl-","count":"IndicatorBox_count__rA9Zm","name":"IndicatorBox_name__qxTq1"};